import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import user from "./modules/user";
import doctor from "./modules/doctor";
// import pulling from './modules/pulling';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {},
  modules: {
    user,
    doctor,
    // pulling
  },
  getters: {},
});

export default store;
